// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-game-tile {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: var(--ion-color-tertiary);
  padding: 0.7rem 1.25rem 0.6rem 0.725rem;
  border-top: 0.5px solid #BEBDBD;
  position: relative;
}

.mobile-image-container {
  display: flex;
  align-items: center;
}
.mobile-image-container .mobile-image-tile {
  overflow: hidden;
  width: 75px;
  height: 75px;
  border: solid 0.5px #BEBDBD;
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}

.details-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 0.6rem;
  flex-grow: 2;
  color: #FFF;
}
.details-container .game-title-landscape {
  font-size: 1rem;
  font-weight: bold;
  margin: 0%;
  padding: 0%;
  white-space: normal;
}
@media (orientation: portrait) {
  .details-container .game-title-landscape {
    display: none;
  }
}
.details-container .game-title-portrait {
  font-size: 1rem;
  font-weight: bold;
  margin: 0%;
  padding: 0%;
  white-space: normal;
}
@media (orientation: landscape) {
  .details-container .game-title-portrait {
    display: none;
  }
}
.details-container .game-subtitle {
  font-size: 0.8rem;
  opacity: 70%;
  margin: 1.5px;
  padding: 0%;
}

.mobile-icons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 18%;
}
.mobile-icons-container .mobile-icons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.content-container {
  min-height: 6rem;
  background-color: var(--ion-color-tertiary);
}
.content-container .no-games-card-container {
  display: flex;
  padding-top: -50px;
  max-width: 80%;
  margin-left: 10%;
  background-color: var(--ion-color-tertiary);
  padding: 0%;
  justify-content: center;
  overflow: hidden;
}
.content-container .no-games-card-container .no-games-card {
  color: #fff;
  display: flex;
  flex-direction: column;
  margin-top: 4px;
}
.content-container .no-games-card-container .no-games-card .title {
  font-weight: bold;
  text-align: center;
}
.content-container .no-games-card-container .no-games-card .subtitle {
  font-weight: bold;
  text-align: center;
}

.jackpot-mobile-counter {
  padding: 1px 0px;
}

.jackpot-mobile-top {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.jackpot-mobile-bottom {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

jackpot-counter {
  position: absolute;
  z-index: 998;
  background: var(--ion-color-primary);
  color: #000;
  font-weight: bold;
  left: 0;
  text-align: center;
  width: 100%;
  font-family: "roboto";
}

ion-icon {
  font-size: 1.5rem;
}

.jackpot-counter-top {
  top: 0;
}

.jackpot-counter-bottom {
  bottom: 0;
}

.heart-icon-desktop {
  z-index: 1000 !important;
  bottom: 3px !important;
  right: 7px !important;
}
@media (max-width: 480px) {
  .heart-icon-desktop {
    right: 3px !important;
  }
}

.heart-icon {
  color: #DA2086;
}

.info-icon-desktop {
  z-index: 1000 !important;
  top: 3px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/mobile-game-tile/mobile-game-tile.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;EACA,uCAAA;EACA,+BAAA;EACA,kBAAA;AACJ;;AAEI;EACY,aAAA;EACA,mBAAA;AAChB;AACgB;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AACpB;;AAGY;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;AAAhB;AAEgB;EACI,eAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAApB;AAEoB;EAPJ;IAQQ,aAAA;EACtB;AACF;AAEgB;EACI,eAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAApB;AAEoB;EAPJ;IAQQ,aAAA;EACtB;AACF;AAEgB;EACI,iBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAApB;;AAIY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AADhB;AAGgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AADpB;;AAOA;EACI,gBAAA;EACA,2CAAA;AAJJ;AAOI;EACI,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,2CAAA;EAEA,WAAA;EACA,uBAAA;EACA,gBAAA;AANR;AAQQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AANZ;AAQY;EACI,iBAAA;EACA,kBAAA;AANhB;AASY;EACI,iBAAA;EACA,kBAAA;AAPhB;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,4BAAA;EACA,2BAAA;AAVJ;;AAaA;EACI,+BAAA;EACA,8BAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;EACA,iBAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AAVJ;;AAaA;EACI,iBAAA;AAVJ;;AAaA;EACI,MAAA;AAVJ;;AAaA;EACI,SAAA;AAVJ;;AAaA;EACI,wBAAA;EACA,sBAAA;EACA,qBAAA;AAVJ;AAYI;EALJ;IAMQ,qBAAA;EATN;AACF;;AAYA;EACI,cAAA;AATJ;;AAYA;EACI,wBAAA;EACA,mBAAA;AATJ","sourcesContent":[".mobile-game-tile {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    background-color: var(--ion-color-tertiary);\n    padding: .7rem 1.25rem .6rem .725rem;\n    border-top: 0.5px solid #BEBDBD;\n    position: relative;\n}\n\n    .mobile-image-container {\n                display: flex;\n                align-items: center;\n\n                .mobile-image-tile {\n                    overflow: hidden;\n                    width: 75px;\n                    height: 75px;\n                    border: solid 0.5px #BEBDBD;\n                    border-radius: 10px;\n                    background-size: cover;\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    position: relative;\n                }\n            }\n\n            .details-container {\n                display: flex;\n                justify-content: center;\n                flex-direction: column;\n                align-items: flex-start;\n                padding-left: .6rem;\n                flex-grow: 2;\n                color: #FFF;\n\n                .game-title-landscape {\n                    font-size: 1rem;\n                    font-weight: bold;\n                    margin: 0%;\n                    padding: 0%;\n                    white-space: normal;\n\n                    @media (orientation: portrait) {\n                        display: none;\n                    }\n                }\n\n                .game-title-portrait {\n                    font-size: 1rem;\n                    font-weight: bold;\n                    margin: 0%;\n                    padding: 0%;\n                    white-space: normal;\n\n                    @media (orientation: landscape) {\n                        display: none;\n                    }\n                }\n\n                .game-subtitle {\n                    font-size: .8rem;\n                    opacity: 70%;\n                    margin: 1.5px;\n                    padding: 0%;\n                }\n            }\n\n            .mobile-icons-container {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                min-width: 18%;\n\n                .mobile-icons {\n                    display: flex;\n                    flex-direction: row;\n                    justify-content: space-between;\n\n                }\n            }\n      \n\n.content-container {\n    min-height: 6rem;\n    background-color: var(--ion-color-tertiary);\n    ;\n\n    .no-games-card-container {\n        display: flex;\n        padding-top: -50px;\n        max-width: 80%;\n        margin-left: 10%;\n        background-color: var(--ion-color-tertiary);\n        ;\n        padding: 0%;\n        justify-content: center;\n        overflow: hidden;\n\n        .no-games-card {\n            color: #fff;\n            display: flex;\n            flex-direction: column;\n            margin-top: 4px;\n\n            .title {\n                font-weight: bold;\n                text-align: center;\n            }\n\n            .subtitle {\n                font-weight: bold;\n                text-align: center;\n            }\n        }\n    }\n}\n\n.jackpot-mobile-counter {\n    padding: 1px 0px;\n}\n\n.jackpot-mobile-top {\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px;\n}\n\n.jackpot-mobile-bottom {\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n}\n\njackpot-counter {\n    position: absolute;\n    z-index: 998;\n    background: var(--ion-color-primary);\n    color: #000;\n    font-weight: bold;\n    left: 0;\n    text-align: center;\n    width: 100%;\n    font-family: 'roboto';\n}\n\nion-icon {\n    font-size: 1.5rem;\n}\n\n.jackpot-counter-top {\n    top: 0;\n}\n\n.jackpot-counter-bottom {\n    bottom: 0;\n}\n\n.heart-icon-desktop {\n    z-index: 1000 !important;\n    bottom: 3px !important;\n    right: 7px !important;\n\n    @media (max-width: 480px) {\n        right: 3px !important;\n    }\n}\n\n.heart-icon {\n    color: #DA2086;\n}\n\n.info-icon-desktop {\n    z-index: 1000 !important;\n    top: 3px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
